import { gql } from '@apollo/client';
import { RichTextFieldsFragment } from '../richText/fragments';
import { ImageEmbedFieldsFragment } from '../imageEmbed/fragments';
import { BriefUserInfoFieldsFragment } from '../users';

const CommentReactionFragment = gql`
  fragment CommentReactionFields on CommentReaction {
    emojiKey
    users {
      ...BriefUserInfoFields
    }
  }
  ${BriefUserInfoFieldsFragment}
`;

const CommentFragment = gql`
  fragment CommentFields on Comment {
    attachedImageEmbed {
      ...ImageEmbedFields
    }
    createdAt
    creator {
      ...BriefUserInfoFields
    }
    id
    isRead
    mentions {
      ...BriefUserInfoFields
    }
    message {
      ...RichTextFields
    }
    reactions {
      ...CommentReactionFields
    }
  }
  ${ImageEmbedFieldsFragment}
  ${BriefUserInfoFieldsFragment}
  ${RichTextFieldsFragment}
  ${CommentReactionFragment}
`;

export const ConversationEntityFragment = gql`
  fragment ConversationEntityFields on ConversationEntity {
    id
    type
  }
`;

export const ConversationThreadFragment = gql`
  fragment ConversationThreadFields on ConversationThread {
    comments {
      ...CommentFields
    }
    createdAt
    creator {
      ...BriefUserInfoFields
    }
    entity {
      ...ConversationEntityFields
    }
    hasUnreadComments
    id
    isResolved
    participants {
      ...BriefUserInfoFields
    }
  }
  ${CommentFragment}
  ${ConversationEntityFragment}
  ${BriefUserInfoFieldsFragment}
`;
